//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// WineRecommendationPage - Wine Recommendation based on Dinner Selection and Preferences
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import React from 'react';
import { withRouter } from './withRouter';
import { SessionInfo } from './App';
import { Button } from '@progress/kendo-react-buttons';
import { Popup } from '@progress/kendo-react-popup';
import { TreeView } from '@progress/kendo-react-treeview';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { ListView } from '@progress/kendo-react-listview';
import { TextArea, Switch } from '@progress/kendo-react-inputs';
import { CallOM,CallOMT,displayError,displayMessage,CTYP,TYP,trace } from './CommonCode.js';
import loadingGif from './images/loading.gif';

import { ReactComponent as MenuBar } from "./images/bars.svg";

class WineRecommendationPage extends React.Component {
  constructor(props) {
    super(props);
    if (!SessionInfo.session || SessionInfo.session === '')
      return;
  }
  menuAnchor = React.createRef();
  logoAnchor = React.createRef();
  state = {
    StoreItems: [],
    WinePreferenceComments: '',
    Recommendation: '',
    RecommendedWines: [],
    showMenu: false,
    showRecommendationPopup: false,
    NotifyMessage: '',
    NotifyIsError: false,
    isLoading: false,
    showGIF : false,
  };

  recommendPos = React.createRef();
  monitorStart = false;
  firstTime = false;
  timerSet = false;
  lastExec = undefined;
  SetLinksTimer = 0;
  compUpdate = true;
  detailOffset = { left: 5,top: 10 };
  //
  async componentDidMount() {
    if (!SessionInfo.session || SessionInfo.session === '')
      return;
    SessionInfo.currentPage = "WineRecommendationPage";
    this.setState({ NotifyMessage: '' });
    // Load meal items for the current store location
    try {
      trace(`WineRecommendation - StoreLocationID: ${SessionInfo.StoreLocationID}`);
      let CD = await CallOM('GetStoreItemsMeals',0,SessionInfo.StoreLocationID,0);
      //trace(`WineRecommendation Meals - CD.x.o: ${CD.x.o}, CD.d.rows: ${JSON.stringify(CD.d.rows)}`);
      if (CD.x.o < 9500 && CD.d && CD.d && CD.d.rows) {
        let StoreItems = CD.d.rows.map(dataItem => Object.assign({ Selected: false },dataItem));
        this.setState({ StoreItems });
      }
    } catch (error) {
      trace(`WineRecommendationPage Mount Error: ${error}`);
    }
    if (SessionInfo.MonitorProcessWR == false && this.monitorStart == false) {
      // Start Monitor   
      console.log(`Starting Monitor Process in WineRecommendationPage`);
      SessionInfo.MonitorProcessWR = true;
      this.monitorProcess();
    }
    if (SessionInfo.AIWineResponse && SessionInfo.AIWineResponse !== '') {             
      if (SessionInfo.AIWIneList)
        this.setState(({ RecommendedWines: SessionInfo.AIWIneList }));
      if (SessionInfo.AICurrentStoreItems)
        this.setState(({ StoreItems: SessionInfo.AICurrentStoreItems }));
      this.setState(({ Recommendation: SessionInfo.AIWineResponse,showRecommendationPopup: true }));
    }
  }
  shouldComponentUpdate() {
    if (this.compUpdate === true)
      return true;
    else
      return false;
  }
  //------------------------------------------------------------------------------------------------
  setTimer() {
    //console.log(`Set Timer Called - loggedOn: ${SessionInfo.loggedOn}, monitorProcess: ${SessionInfo.MonitorProcessWR}, timerSet: ${this.timerSet}`);
    if (SessionInfo.loggedOn === true && SessionInfo.MonitorProcessWR === true) {
      //  if (this.timerSet === false) {
      this.timerSet = true;
      this.timeout = setTimeout(this.monitorProcess.bind(this),1000); // in milliseconds 
    }
  }
  //----- Timer Process - Application Control Logic -------------------------------------------------
  monitorProcess = async () => {
    //let elapsed = this.timeSinceLastCall();
    //if (elapsed < 800 && this.firstTime === false) { // Prevent Multiple Calls within 1 second)
    //  console.log(`monitor proc Exit - Elapsed: ${elapsed} ms`);
    //  return;
    //}
    //console.log(`WineRecommendationPage Monitor Process Active - AsyncTxID: ${SessionInfo.AsyncTxID}`);
    this.firstTime = false;
    this.timerSet = false;
    this.monitorStart = true;
    if (SessionInfo.forceLogoff === true)
      this.props.navigate("/Login");
    if (SessionInfo.SetCurrentTab) {
      SessionInfo.SetCurrentTab = false;
      await this.selectTab(SessionInfo.GoToTab);
    }
    if (SessionInfo.AsyncTxID > 0) {
      let CD = await CallOMT("RetrieveAsyncTx",CTYP.INT,SessionInfo.AsyncTxID);
      console.log(`RetrieveAsyncTx CD: ${JSON.stringify(CD)}, txid: ${SessionInfo.AsyncTxID}`);
      SessionInfo.SaveAsyncTxID = SessionInfo.AsyncTxID;
      if (CD.x.p >= 10) { // Completed  
        try {
          console.log(`-------- Transaction: ${SessionInfo.AsyncTxID} Complete ---------------`);
          if (CD.x.p === 15) { // Error
            //displayError(`Error in Question Processing: ${CD.x.m}`);
            this.setState({ AnswerDetail: `Error fetching Wine Recommendation` });
            SessionInfo.AsyncTxID = 0;
            SessionInfo.AsyncCounter = 0;
          } else if (CD.x.p === 10) { //---- Success - Retrieve Answer ----
            let CD = await CallOMT("RetrieveWRAnswer",CTYP.INT,SessionInfo.AsyncTxID);
            console.log(`WR Answer Returned - TxID: ${SessionInfo.AsyncTxID}, Async Cnt: ${SessionInfo.AsyncCounter}, length: ${CD.d.length}`);
            await new Promise(resolve => {
              this.setState({ Recommendation: CD.d,showRecommendationPopup: true },resolve);
            });
            try {
              SessionInfo.AIWineResponse = CD.d; // Store in SessionInfo for retrieval if user navigates away and back to page
              console.log(`AIResponse set in SessionInfo - length: ${SessionInfo.AIWineResponse.length}`);
            }
            catch (error) {
              console.log(`Error in setting AIResponse: ${error}`);
            }
            CD = await CallOMT("RetrieveWineList",CTYP.INT,SessionInfo.AsyncTxID);
            console.log(`WineList Returned - TxID: ${SessionInfo.AsyncTxID}, List: ${JSON.stringify(CD)}`);
            if (CD.d) {
              await new Promise(resolve => {
                this.setState({ RecommendedWines: CD.d, showGIF: false },resolve);
              });
            }
            SessionInfo.AIWineList = CD.d; // Store in SessionInfo for retrieval if user navigates away and back to page
            SessionInfo.AICurrentStoreItems = this.state.StoreItems; // Store current meal selection in SessionInfo for retrieval if user navigates away and back to page
            console.log(`AIWineList set in SessionInfo - length: ${SessionInfo.AIWineList.length}`);
            SessionInfo.AsyncTxID = 0;
            SessionInfo.AsyncCounter = 0;
          }
        } catch (error) {
          console.log(`Error in monitorProcess asyncTx retrieval: ${error}`);
        }
      }
    }
    this.setTimer();
  }
  // 
  gotoLanding = async () => {
    trace("Go To LandingPage");
    this.props.navigate("/LandingPage");
  }
  openMenu = (event) => {
    event.stopPropagation();
    this.setState({ showMenu: true });
  }
  onMenuItemClick = async (event) => {
    trace(`menu event Item: ${event.item.text}`);
    if (SessionInfo.currentItem !== undefined) {
      SessionInfo.currentItem.Selected = false;
    }
    SessionInfo.currentItem = event.item;
    event.item.Selected = true;
    event.item.expanded = true;
    SessionInfo.MenuSelect = event.item;
    this.setState({ showMenu: false });
    if (SessionInfo.menuAction !== undefined) {
      await SessionInfo.menuAction();
    }
    this.forceUpdate();
  }
  closePopups = () => {
    this.setState({ showMenu: false });
  }
  notifyTimeout = null;
  notify = (msg,isError = false,keep = false) => {
    if (this.notifyTimeout)
      clearTimeout(this.notifyTimeout);
    this.setState({ NotifyMessage: msg,NotifyIsError: isError });
    if (keep === false) {
      this.notifyTimeout = setTimeout(() => {
        this.setState({ NotifyMessage: '' });
        this.notifyTimeout = null;
      },6000);
    }
  }
  onMealSelectionChange = (event) => {
    //  let current = this.state.StoreItems.findIndex(dataItem => dataItem === event.dataItem);
    //  let StoreItems = this.state.StoreItems.slice();
    //  StoreItems[current].Selected = !StoreItems[current].Selected;
    //  this.setState({ StoreItems });
  }
  BoolSelectCell = (props) => {
    //console.log(`BoolSelectCell field: ${props.field}, props: ${JSON.stringify(props.dataItem)}`);
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      let current = this.state.StoreItems.findIndex(p => p.StoreItemID === props.dataItem.StoreItemID);
      console.log(` current: ${current}, StoreItemID: ${props.dataItem.StoreItemID}`);
      let StoreItems = this.state.StoreItems.slice();
      StoreItems[current][props.field] = !StoreItems[current][props.field];
      console.log(` current: ${current}, ${props.field}: ${StoreItems[current][props.field]}`);
      this.setState({ StoreItems });
    }
    return (<td><Switch size="small" checked={value} onChange={handleChange} style={{ color: 'green' }} /></td>);
  }
  BoolCheckCell = (props) => {
    //console.log(`BoolSelectCell field: ${props.field}, props: ${JSON.stringify(props.dataItem)}`);
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      let current = this.state.StoreItems.findIndex(p => p.StoreItemID === props.dataItem.StoreItemID);
      console.log(` current: ${current}, StoreItemID: ${props.dataItem.StoreItemID}`);
      let StoreItems = this.state.StoreItems.slice();
      StoreItems[current][props.field] = !StoreItems[current][props.field];
      console.log(` current: ${current}, ${props.field}: ${StoreItems[current][props.field]}`);
      this.setState({ StoreItems });
    }
    return (
      <td style={{ textAlign: 'center', backgroundColor: SessionInfo.orderBGColor }}>
        <input 
          type="checkbox" 
          checked={value} 
          onChange={handleChange} 
          style={{ 
            width: "18px",
            height: "18px",
            accentColor: '#04684ff8',
            cursor: 'pointer'
          }} 
        />
      </td>
    );
  }
  ItemNameCell = (props) => {
    return (
      <td style={{ backgroundColor: SessionInfo.orderBGColor, color: '#04684ff8' }}>
        {props.dataItem[props.field]}
      </td>
    );
  }
  WineListItemRender = (props) => {
    return (
      <div style={{ 
        backgroundColor: SessionInfo.orderBGColor, 
        color: '#04684ff8',
        padding: '8px 12px',
        borderBottom: '1px solid #e0e0e0'
      }}>
        {props.dataItem}
      </div>
    );
  }
  BoolCell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      props.onChange({ dataItem: props.dataItem,field: props.field,syntheticEvent: e.syntheticEvent,value: !value }); //e.target.value
    }
    let keyValue = Object.values(props.dataItem)[0] ?? 0; // Current Key-Field Value
    //console.log(`BoolCell - field: ${props.field}, value: ${value}, keyValue: ${keyValue}, editor: ${JSON.stringify(props.dataItem)}`);
    if (props.editor[keyValue.toString()]) {
      return (
        <td>
          <input type="checkbox" checked={value} onChange={handleChange} style={{ color: "brown",width: "18px",height: "18px" }} />
        </td>
      )
    } else {
      return (
        <td>
          <input type="checkbox" checked={value} readOnly={true} style={{ backgroundColor: "green",width: "14px",height: "14px" }} />
        </td>
      )
    }
  }
  chgFldVal = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }
  chgTAFldVal = (event) => {
    this.setState({ [event.target.name]: event.value });
  }
  recommendWine = async () => {
    let selectedMeals = this.state.StoreItems.filter(item => item.Selected === true);
    if (selectedMeals.length === 0) {
      this.notify('Please select at least one meal for your dinner.',true);
      return;
    }
    let mealNames = selectedMeals.map(item => item.ItemName).join(', ');
    let comments = this.state.WinePreferenceComments || '';
    trace(`Recommend Wine - Meals: ${mealNames}, Comments: ${comments}`);
    this.setState({ isLoading: true,Recommendation: '' });
    try {
      let mealIDs = selectedMeals.map(item => item.StoreItemID);                                              
      //this.notify('Recommending wine based on your meal selection and preferences. This may take 20 seconds or so ...',false,true);
      this.setState({ Recommendation: 'Getting wine recommendation based on your meal selection and preferences ... \r\nThis may take 20 seconds or so ...' });
      this.setState({ showRecommendationPopup: true });
      let CD = await CallOM('GetWineRecommendation',0,SessionInfo.StoreLocationID,CTYP.TypParm,[TYP.IAR,mealIDs,TYP.STR,comments]);
      if (CD.d !== undefined) {
        this.setState({ NotifyMessage: '' });
        //console.log(`Recommend Wine CD: ${JSON.stringify(CD)}`);
        SessionInfo.AsyncTxID = Number(CD.d); // Transaction ID returned from server to retrieve answer in monitorProcess
        SessionInfo.AsyncCounter = 0;
        if (SessionInfo.AsyncTxID > 0) {
          this.setState({ showGIF: true });
        }
        try {
          this.setState({ AnswerDetail: `Transaction ID: ${CD.d}` });
        } catch (error) {
          console.log(`Error in AskQuestion: ${error}`);
          this.setState({ AnswerDetail: "" });
        }
      }
      else
        this.setState({ AnswerDetail: "Wine Recommentation Request Failed" });
    } catch (error) {
      trace(`Recommend Wine Error: ${error}`);
      this.notify('Error getting wine recommendation.',true);
    }
    //-------------------------------------------------   
    //let CD = await CallOMT("QuestionAsyncTx",CTYP.STR,this.CompleteQuestion,CTYP.STR,continuePrompt,CTYP.INT,VDBReferenceType,CTYP.INT,AIProcessTypeCtrl,CTYP.INT,AITypeID,CTYP.INT,AIPromptDictVal);
    //// Note: Answer retrieved in monitorProcess which calls RetrieveAsyncTx and RetrieveWRAnswer based on AsyncTxID returned from QuestionAsyncTx
    //RemoveBusyIndicator();
    //console.log(`AskQuestion SessionID: ${SessionInfo.sequenceid}, asyncTxID: ${CD.d}`);
    //this.setState({ isSubmitting: false });
    //// Clear on return
    //console.log("Return from QuestionAsyncTx: " + JSON.stringify(CD));
    //console.log(`Return from QuestionAsyncTx SessionID: ${SessionInfo.sequenceid}, txid: ${SessionInfo.AsyncTxID}`);
    //if (CD.d !== undefined) {
    //  SessionInfo.AsyncTxID = Number(CD.d); // Transaction ID returned from server to retrieve answer in monitorProcess
    //  SessionInfo.AsyncCounter = 0;
    //  if (SessionInfo.AsyncTxID > 0) {
    //    this.setState({ showGIF: true });
    //  }
    //  try {
    //    this.setState({ AnswerDetail: `Transaction ID: ${CD.d}` });
    //  } catch (error) {
    //    console.log(`Error in AskQuestion: ${error}`);
    //    this.setState({ AnswerDetail: "" });
    //  }
    //}
    //else
    //  this.setState({ AnswerDetail: "Submit Question Failed" });
    //-------------------------------------------------
    this.setState({ isLoading: false });
  }
  parseWineNames = (recommendation) => {
    let wines = [];
    let lines = recommendation.split('\n');
    let id = 1;
    for (let line of lines) {
      let trimmed = line.replace(/^[\s\-\*\d\.\)]+/,'').trim();
      if (trimmed.length > 2 && trimmed.length < 120 && !trimmed.endsWith(':') && (line.match(/^\s*[\-\*\d]/) || line.match(/wine|cabernet|merlot|chardonnay|pinot|sauvignon|riesling|zinfandel|syrah|malbec|ros[eé]/i))) {
        wines.push({ WineID: id++,WineName: trimmed,Selected: false });
      }
    }
    return wines;
  }
  WineBoolSelectCell = (props) => {
    let value = props.dataItem[props.field];
    value = (value === true || value === 'true');
    const handleChange = (e) => {
      let current = this.state.RecommendedWines.findIndex(p => p.WineID === props.dataItem.WineID);
      let RecommendedWines = this.state.RecommendedWines.slice();
      RecommendedWines[current][props.field] = !RecommendedWines[current][props.field];
      this.setState({ RecommendedWines });
    }
    return (<td><Switch size="small" checked={value} onChange={handleChange} style={{ color: 'green' }} /></td>);
  }
  closeRecommendationPopup = () => {
    SessionInfo.AsyncTxID = 0; // Clear any pending transaction
    this.setState({ showRecommendationPopup: false });
  }
  clearSelection = async () => {
    let StoreItems = this.state.StoreItems.slice();
    StoreItems.forEach(item => { item.Selected = false; item.Choice = false; });
    await new Promise(resolve => {
      this.setState({ StoreItems,WinePreferenceComments: '',Recommendation: '',RecommendedWines: [],showRecommendationPopup: false },resolve);
    }); 
    SessionInfo.AIWIneList = []; // Clear stored wine list
    SessionInfo.AIWineResponse = ''; // Clear stored AI response
    SessionInfo.AICurrentStoreItems = undefined; // Clear stored meal selection
  }
  //----------------------------------------------------------------------------------------------------------------------------------
  render() {
    return (
      <div id="WineRecommendationPage" className="pageMain">

        <div id="hdr" className="header" onClick={(e) => this.closePopups(e)}>
          <div className="headerLogoLeft">
            {SessionInfo.HasLandingPage ?
              <a id="headerLogo" ref={this.logoAnchor} style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})`,backgroundPosition: 'left top',backgroundRepeat: 'no-repeat',backgroundSize: 'cover',marginLeft: '8px',marginTop: '5px' }} onClick={(e) => this.gotoLanding()} />
              :
              <a id="headerLogo" ref={this.logoAnchor} style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})`,backgroundPosition: 'left top',backgroundRepeat: 'no-repeat',backgroundSize: 'cover',marginLeft: '8px',marginTop: '5px' }} href={SessionInfo.RestaurantURL} target="_blank" rel="noopener noreferrer" />}
          </div>
          <div className="headerCenter">
            <div className="headerCenterMenu">
              <MenuBar alt="" fill={SessionInfo.headingTextColor} id="MenuBtn" title={`View Menu`} className="functionImageL" onClick={(e) => this.openMenu(e)} ref={this.menuAnchor} />
            </div>
            <div className="headerCenterTop">
              <span className='landingHeadTextLarge'>&nbsp;&nbsp;&nbsp;Wine Recommendations</span>
              <br />
              {this.state.NotifyMessage !== '' ?
                <div style={{ padding: '6px 12px',fontSize: '14px',fontWeight: '500',color: this.state.NotifyIsError ? '#d32f2f' : '#2e7d32',backgroundColor: this.state.NotifyIsError ? '#fdecea' : '#edf7ed',border: this.state.NotifyIsError ? '1px solid #f5c6cb' : '1px solid #c3e6cb',borderRadius: '6px',textAlign: 'center',marginTop: '4px' }}>
                  {this.state.NotifyMessage}
                </div>
                : null}
              {/* Buttons */}
              <div style={{ marginTop: '40px', marginBottom: '5px', textAlign: 'center' }}>
                <Button icon="search" look="outline" className="largeButton" onClick={this.recommendWine} disabled={this.state.isLoading} style={{ borderColor: 'white' }}>
                  {this.state.isLoading ? '\u00A0Recommending...\u00A0' : '\u00A0Recommend Wine\u00A0'}
                </Button>
                &nbsp;&nbsp;
                <Button icon="reset" look="outline" className="largeButton" onClick={this.clearSelection} style={{ borderColor: 'white' }}>&nbsp;Clear&nbsp;</Button>
              </div>
            </div>
          </div>
        </div>

        <Popup anchor={this.menuAnchor.current} show={this.state.showMenu} popupClass={'popupMenu'} >
          <div className="mainMenu">
            <a id="headerLogo" style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})`,backgroundPosition: 'left top',backgroundRepeat: 'no-repeat',backgroundSize: '100px 60px' }} href="http://www.omnovos.com" target="_blank" rel="noopener noreferrer" />
            <div className="menuTree">
              {SessionInfo.AppCfg.HasScanAndPay === false ?
                <br /> : null}
              {SessionInfo.defaultLogon === true ?
                <br /> : null}
              <TreeView
                data={SessionInfo.MenuControlNQR}
                size='large' draggable='false' selection='single'
                onItemClick={this.onMenuItemClick}
                className='menuTreeSub'
                item={props => [<span key={props.item.key} className={props.item.className}>{props.item.icon}{props.item.space}{props.item.text}</span>]}
              />
            </div>
          </div>
        </Popup>

        <div className="contactEdit" style={{ height: 'calc(var(--screen-height) - 108px)',overflowY: 'auto',top: '108px' }}>
          <div className="contactBox" style={{ height: 'auto',overflow: 'visible' }}>
            {/* ===== Section 1: Select Dinner Meals ===== */}
            <div style={{ marginBottom: '4px' }} ref={(div) => { this.recommendPos = div; }}>
              <label style={{ fontSize: '16px',fontWeight: 'bold',color: SessionInfo.ECV.BrandColor }}>Identify Your Menu Choices</label>
            </div>
            <div style={{ backgroundColor: SessionInfo.orderBGColor }}>
              <Grid
                data={this.state.StoreItems}
                className="wineGrid"
                style={{ width: '100%',maxHeight: '400px' }}
                onRowClick={this.onMealSelectionChange}
                dataItemKey={"StoreItemID"}
                size={"small"}
                resizable={false}
              >
                <GridColumn field="Selected" cells={{ data: this.BoolCheckCell }} title="Select" width='70px' editor={this.state.editProductCategorys} />
                <GridColumn field="ItemName" cells={{ data: this.ItemNameCell }} title="Meal(s) and/or Appetizer" />
              </Grid>
            </div>

            {/*<GridColumn field="Selected" title="Select" cells={{ data: this.BoolSelectCell }} width='70px' />*/}
            {/* ===== Section 2: Wine Preference Comments ===== */}
            <div className="editFieldW" style={{ height: 'auto',paddingTop: '14px',paddingBottom: '5px' }}>
              <label style={{ fontSize: '16px',color: SessionInfo.ECV.BrandColor }}>Any additional wine info - references, restrictions, or notes? (Note that the wine recommendations only include wines currently in our cellar)</label>
              <TextArea name="WinePreferenceComments" rows={4} style={{ width: '97%',fontSize: '14px',borderRadius: '10px',border: '1px solid #ccc',marginTop: '5px' }} value={this.state.WinePreferenceComments} onChange={(e) => this.chgTAFldVal(e)} />
            </div>
            {/* ===== Section 3: Recommend Button ===== */}
            <div style={{ marginTop: '20px',marginBottom: '10px',textAlign: 'center' }}>
              <Button icon="search" look="outline" className="largeButton" onClick={this.recommendWine} disabled={this.state.isLoading} style={{ borderColor: SessionInfo.ECV.BrandColor }}>
                {this.state.isLoading ? '\u00A0Recommending...\u00A0' : '\u00A0Recommend Wine\u00A0'}
              </Button>
              &nbsp;&nbsp;
              <Button icon="reset" look="outline" className="largeButton" onClick={this.clearSelection} style={{ borderColor: SessionInfo.ECV.BrandColor }}>&nbsp;Clear&nbsp;</Button>
            </div>

          </div>
        </div>

        {/* ===== Wine Recommendation Popup ===== */}
        <Popup anchor={this.logoAnchor.current} show={this.state.showRecommendationPopup} popupClass={'popupText'} >
          <div style={{ backgroundColor: '#fff',borderRadius: '12px',width: '500px',maxWidth: '95vw',minHeight: '250px', display: 'flex',flexDirection: 'column',boxShadow: '0 8px 32px rgba(0,0,0,0.3)',marginTop: '0' }} onClick={(e) => e.stopPropagation()}>
            {/* Popup Header */}
            {this.state.Recommendation === '' ?
              <div style={{ padding: '12px 18px',borderBottom: '1px solid #ddd',display: 'flex',justifyContent: 'space-between',alignItems: 'center' }}>
                <label style={{ fontSize: '18px',fontWeight: 'bold',color: SessionInfo.activeColor }}>Wine Recommendation</label>
              </div> : null}
            {/* Recommended Wines List */}
            {this.state.RecommendedWines.length > 0 &&
              <div style={{ padding: '10px 18px 0 18px' }}>
                <label style={{ fontSize: '14px',fontWeight: 'bold',color: SessionInfo.ECV.BrandColor,marginBottom: '6px',display: 'block' }}>Recommended Wines</label>
                <ListView
                  data={this.state.RecommendedWines}
                  item={this.WineListItemRender}
                  style={{ 
                    width: '100%',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                />
              </div>
            }
            {/* AI Recommendation Scroll Box */}
            <div style={{ padding: '10px 18px 18px 18px',flex: 1,overflow: 'hidden',display: 'flex',flexDirection: 'column' }}>
              <label style={{ fontSize: '14px',fontWeight: 'bold',color: SessionInfo.ECV.BrandColor,marginBottom: '6px',display: 'block' }}>Recommendation Details</label>
              <div style={{ flex: 1,overflowY: 'auto',padding: '12px',backgroundColor: '#f9f5f0',border: '1px solid #d4c5a9',borderRadius: '10px',fontSize: '14px',lineHeight: '1.6',color: '#333',whiteSpace: 'pre-wrap' }}>
                {this.state.Recommendation}
              </div>
            </div>
            {this.state.showGIF && (
              <div style={{ padding: '10px 18px 0 18px',maxWidth: '200px',maxHeight: '200px' }}>
                {/*<h4 style={{ margin: 0 }}>Processing ... </h4>*/}
                <div className="loadingWrap">
                  <img src={loadingGif} alt="Processing..." className="loadingImg" />
                </div>
              </div>
            )}
            {/* Popup Footer */}
            <div style={{ padding: '10px 18px',borderTop: '1px solid #ddd',textAlign: 'center' }}>
              <Button icon="close" look="outline" className="largeButton" onClick={this.closeRecommendationPopup}>&nbsp;Close&nbsp;</Button>
            </div>
          </div>
        </Popup>

      </div>
    );
  }
}

export default withRouter(WineRecommendationPage);
